import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { trigger, transition, animate, style } from '@angular/animations';

import { AlertService } from './alert.service';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css'],
    animations: [
        trigger('easeInOutRow', [
            transition(':enter', [
                style({ height: '0', opacity: '.25' }),
                animate(500),
                style({ transform: 'translateY(-100%)', height: '100%', opacity: '1' }),
            ]),
            transition(':leave', [
                animate(500, style({ opacity: '0', height: '0' })),
            ]),
        ]),
        trigger('easeInOutGroup', [
            transition(':enter', [
                style({ transform: 'translateY(-100%)' }),
                animate(500),
            ]),
            transition(':leave', [
                animate(500, style({ opacity: '0', transform: 'translateY(-100%)' })),
            ]),
        ]),
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertComponent implements OnInit {
  navStart: Observable<NavigationStart>;

  constructor(public alertService: AlertService, private router: Router) {
    this.navStart = router.events.pipe(
      filter((evt) => evt instanceof NavigationStart)
    ) as Observable<NavigationStart>;
  }

  ngOnInit() {
    this.navStart.subscribe(() => {
      this.alertService.clear();
    });
  }
}
